import Vue from 'vue';
import store from './../../store';
import unitOfMeasureTransformer from './../../transformers/unitOfMeasure';
import paginationTransformer from '../../transformers/pagination';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const unitOfMeasures = unitOfMeasureTransformer.fetchCollection(data.data);
  const pagination = paginationTransformer.fetch(data.pagination);

  store.dispatch('fetchPaginatedUnitOfMeasures', { unitOfMeasures, pagination });
  resolve({ unitOfMeasures, pagination });
};

const failed = (error, reject) => reject(error);


export default (params = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl('/unit_of_measures', params))
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/unitOfMeasure/items.js